import FishFamilies from './FishFamilies'

export default FishFamilies
